<template>
    <div class="min-h-screen flex flex-col justify-center items-center">
        <div
            class="container max-w-md mx-auto h-full flex bg-white rounded-lg shadow overflow-hidden"
        >
            <div class="w-full p-8">
                <router-view :key="$route.name"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
